import { Component, OnInit } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { Subscription } from 'rxjs';
import { ActivitiesService } from 'src/app/services/activities/activities.service';

@Component({
  selector: 'app-activities',
  templateUrl: './activities.component.html',
  styleUrls: ['./activities.component.scss']
})
export class ActivitiesComponent implements OnInit {
  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: false,
    touchDrag: false,
    pullDrag: false,
    dots: true,
    navSpeed: 700,
    autoplay:true,
    navText: ['', ''],
    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 2
      },
      740: {
        items: 3
      },
      940: {
        items: 6
      }
    },
    nav: true
  }
  activities:any[];
  sub:Subscription[]=[];
  constructor(private activitiesService:ActivitiesService) { }

  ngOnInit(): void {
    
    this.activitiesService.getActivitiesList();
    this.sub[0]= this.activitiesService.activitiesList.snapshotChanges().subscribe(
      list=>{
      this.activities=  list.map(item=>{  return {
        $key:item.key,
        ... item.payload.val()
      }});
      this.activities=this.activities.reverse();
      }
      
      );
  }
  
  ngOnDestroy(){
    this.sub.forEach(s=>s.unsubscribe());
  }
}
